import {
  useCallback, useEffect, useState,
} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Spin } from 'antd';

import { IconArrowLeft, IconComment } from '../../Common/Icon';
import { useBusiness } from '../../../store/business';
import { useBusinessById } from './useBusinessById';
import BusinessCard from './BusinessCard';
import { useAuth } from '../../../store/auth';
import PostList from '../../Common/PostList';
import PostListSortBy from '../../Common/PostList/SortBy';
import { PostListParams } from '../../../store/post/list';
import useAuthModals from '../../Layout/Menu/useAuthModals';

import styles from './index.module.scss';

function BusinessViewContent() {
  const { businessId } = useParams();
  const navigate = useNavigate();
  const { content, openLoginModal } = useAuthModals();

  const { getBusinessById } = useBusinessById();
  const { byId } = useBusiness();
  const { user } = useAuth();

  const [filter, setFilter] = useState<Partial<PostListParams>>({
    businessId,
    orderBy: 'DESC',
    orderByColumn: 'createdAt',
    status: 'published',
  });

  const getBusiness = useCallback(() => {
    if (businessId) {
      getBusinessById({ id: businessId });
    }
  }, [businessId]);

  useEffect(getBusiness, [businessId, user]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <Button
            className={styles.btnBack}
            type="text"
            onClick={() => navigate('/share-your-two-cents')}
          >
            <IconArrowLeft className={styles.btnBackIcon} />
            Back to Share Your Two Cents
          </Button>

          <Spin spinning={byId.loading}>
            <div className={styles.businessCardWrapper}>
              <BusinessCard
                business={byId.response}
                getBusiness={getBusiness}
              />
            </div>

            <div className={styles.innerContainer}>
              {content}
              <Button
                className={styles.btnCreateNewPost}
                icon={<IconComment />}
                onClick={() => (user ? navigate('/create-new-post') : openLoginModal())}
              >
                {/* add */}
                Create New Post
              </Button>

              <div className={styles.asdsa}>
                <div className={styles.postTotal}>
                  {`${byId.response?.numberOfPostsTotal || 0} Post${
                    (byId.response?.numberOfPostsTotal || 0) !== 1 ? 's' : ''
                  }`}
                </div>

                {(byId.response?.numberOfPostsTotal || 0) > 1 ? (
                  <PostListSortBy
                    onChange={(order) => setFilter((prev) => ({ ...prev, ...order }))}
                    orderBy={filter.orderBy}
                    orderByColumn={filter.orderByColumn}
                  />
                ) : null}
              </div>
            </div>
          </Spin>

          <div className={styles.innerContainer}>
            <PostList filter={filter} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessViewContent;
